import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const auth = useAuth();

  if (!auth.verified) {
    return null;
  }

  if (!auth.user) {
    return <Navigate to="/" replace />;
  }

  return children;
};
